import axios from "axios";

// Heroku corta las peticiones de más de 30 s: el Excel (~50 MB) se sube en trozos
const CHUNK_SIZE = 5 * 1024 * 1024;

class PptoUpload {
  constructor() {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_PUBLIC_DOMAIN_3,
      withCredentials: true
    });
  }

  // onProgress(bytesEnviados) se llama después de cada trozo
  upload = async (file, onProgress) => {
    const { data } = await this.api.post("/admin/ppto/upload", { name: file.name, size: file.size });
    for (let offset = 0; offset < file.size; offset += CHUNK_SIZE) {
      const chunk = file.slice(offset, offset + CHUNK_SIZE);
      await this.api.post(`/admin/ppto/upload/${data.id}?offset=${offset}`, chunk, {
        headers: { "Content-Type": "application/octet-stream" }
      });
      onProgress(Math.min(offset + CHUNK_SIZE, file.size));
    }
    return data.id;
  }

  process = (files, dryRun) => {
    return this.api
      .post("/admin/ppto/process", { files, dryRun })
      .then(({ data }) => data.id);
  }

  job = (id, from) => {
    return this.api
      .get(`/admin/ppto/jobs/${id}`, { params: { from } })
      .then(({ data }) => data);
  }

  csv = (id) => {
    return this.api
      .get(`/admin/ppto/jobs/${id}/csv`, { responseType: "blob" })
      .then(({ data }) => data);
  }
}

// Mensaje de error que devuelve el backend, o uno genérico si no hay respuesta
export const errorMessage = (error) =>
  (error.response && error.response.data && error.response.data.message) ||
  "No se ha podido conectar con el servidor";

const pptoService = new PptoUpload();

export default pptoService;
